import { Component,OnInit, Output, ElementRef, EventEmitter, Input } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';

import{SystemxService } from 'src/app/services/systemx.service';
import { ModelService  } from 'src/app/services';

@Component({
  selector: 'bart-cmdmodel',
  templateUrl: './cmdmodel.component.html',
  styleUrls: ['./cmdmodel.component.scss']
})
export class CmdmodelComponent implements OnInit {

  @Input() CurrentComboValue : string;
  @Output() btnModelCmoboClicked = new EventEmitter();  
  public modelList: SelectItem[]; 
  
  getmodelParams = {
    manufacturerId	:	'',
    equipmentTypeId	:	'',  
    modelId				:'',  
    SearchTerm			:'',  
    modelsOnly			:''
  };
  constructor(private _modelService: ModelService, private _systemxService: SystemxService) { }

  ngOnInit() {    
    // if(this.CurrentComboValue!=null)
    // {
    //   this.selectedFacility = this.CurrentComboValue;
    // }
    // this.userFacilities = [];
    // for (let i = 0; i < 10000; i++) {
    //     this.userFacilities.push({label: 'Item ' + i, value: 'ItemNumber ' + i});
    // }
   this.getModels();
  }
  public ComboChange(event)
  {
    alert(this.CurrentComboValue);
    let changedValue = event.value;
    let domEvent = event.originalEvent;
    this.btnModelCmoboClicked.emit(this.CurrentComboValue);
  }
  getModels() {
    if (this.getmodelParams != null) {
      var GETMODELS = this.getmodelParams;    
      this._modelService.getModels( JSON.stringify(GETMODELS))
      .subscribe((allUserLocationsResponse: any) => {
        //this.userLocations = allUserLocationsResponse.response;
        if(allUserLocationsResponse.response.locationFacilities.length> 0)
        this.modelList = [];
        for (let c of allUserLocationsResponse.response.locationFacilities) {
          this.modelList.push({ label: c.facilityDisplayName, value:c.facilityMasterID});;
        }
          
        }, (respose: Response) => {
          this.modelList = [];
          // handle error here
        }
      );
    }
    
  }  
}
